import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import "../styles/UserDashboard.css";

export default function UserDashboard() {
  const [house, setHouse] = useState(null);
  const [payAmount, setPayAmount] = useState("");
  const navigate = useNavigate();

  const house_id = localStorage.getItem("house_id");

  // 🔁 Fetch house data
  useEffect(() => {
    if (!house_id) {
      navigate("/user-login");
      return;
    }

    fetch(`http://localhost/belpimpalgaon/api/get_user_house.php?house_id=${house_id}`)
      .then(res => res.json())
      .then(data => setHouse(data))
      .catch(() => alert("❌ Server Error"));
  }, [house_id, navigate]);

  // 💧 Manual payment update (admin records)
  const handlePayment = async () => {
    if (!payAmount) {
      alert("रक्कम टाका");
      return;
    }

    const res = await fetch("http://localhost/belpimpalgaon/api/pay_bill.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        house_id,
        amount: payAmount
      })
    });

    const data = await res.json();
    if (data.status === "success") {
      alert("✅ Payment Successful");
      window.location.reload();
    } else {
      alert("❌ Payment Failed");
    }
  };

  // 🚪 Logout
  const handleLogout = () => {
    localStorage.clear();
    navigate("/user-login");
  };

  if (!house) return <h3 style={{ textAlign: "center" }}>Loading...</h3>;

  const remaining = house.total_amount - house.paid_amount;

  // 🔗 UPI QR link
  const upiLink = `upi://pay?pa=9130372467-2@ybl&pn=GramPanchayat%20Belpimpalgaon&am=${remaining}&cu=INR&tn=Water%20Bill%20House%20${house.house_id}`;


  return (
    <div className="dash-wrap">

      <h1 className="dash-title">🏠 माझे घर</h1>

      {/* HOUSE CARD */}
      <div className="dash-card">
        <p><b>House ID :</b> {house.house_id}</p>
        <p><b>Owner :</b> {house.owner_name}</p>
        <p><b>Members :</b> {house.member_count}</p>

        <hr />

        <p><b>Total Bill :</b> ₹{house.total_amount}</p>
        <p><b>Paid :</b> ₹{house.paid_amount}</p>
        <p className={remaining === 0 ? "paid" : "pending"}>
          <b>Remaining :</b> ₹{remaining}
        </p>
      </div>

      {/* 🔳 QR PAYMENT */}
      {remaining > 0 && (
        <div className="qr-section">
          <h3>💧 पाणीपट्टी भरण्यासाठी QR Scan करा</h3>

          <QRCodeSVG value={upiLink} size={220} />

          <p className="upi-text">
            UPI Number : <b>9130372467</b>
          </p>
          <p className="note">
            Google Pay / PhonePe / Paytm वापरून Scan करा
          </p>
        </div>
      )}

      {/* 🚪 LOGOUT LAST */}
      <div className="logout-box">
        <button onClick={handleLogout}>🚪 Logout</button>
      </div>

    </div>
  );
}
